<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div epub:type="bodymatter">
<section epub:type="division">
<h1 class="chapter1" id="c010"><a id="page34"></a><b>1758</b></h1>
<h1 class="chapter0">Human Computers Predict Halley’s Comet</h1>
<p class="nonindent_line"><b>Edmond Halley</b> (1656–1742)<b>, Alexis-Claude Clairaut</b> (1713–1765)<b>, Joseph Jérôme Lalande</b> (1732–1807)<b>, Nicole-Reine Lepaute</b> (1723–1788)</p>
<p class="nonindent">The discovery of Kepler’s laws of planetary motion and Isaac Newton’s more general laws of motion and gravity encouraged scientists to seek elegant mathematical models to describe the world around them. Edmond Halley, the editor of Newton’s <i>Principia</i> (1687), used Newton’s calculus and laws to show that a comet seen in the night sky in 1531 and 1682 must be the same object. Halley’s work depended on the fact that the comet’s orbit was influenced not just by the sun, but also by the other planets in the solar system—especially Jupiter and Saturn. But Halley could not come up with an exact set of equations to describe the comet’s trajectory.</p>
<p class="indent">Alexis-Claude Clairaut was a French mathematician who devised a clever solution to the problem. But it wasn’t mathematically elegant: instead of solving the problem symbolically, his method solved the problem numerically—that is, with a series of arithmetic calculations. He worked with two friends, Joseph Jérôme Lalande and Nicole-Reine Lepaute, during the summer of 1758, and the three systematically plotted the course of the comet, calculating the wanderer’s return to within 31 days.</p>
<p class="indent">This approach of using numerical calculations to solve hard science problems quickly caught on. In 1759, Lalande and Lepaute were hired by the French Académie des Sciences to contribute computations to the <i>Connaissance des Temps,</i> the official French almanac; five years later, the English government hired six human computers to create its own almanac. These printed tables charted the anticipated positions of the stars and planets and were the basis of celestial navigation, allowing the European powers to build out their colonies.</p>
<p class="indent">In 1791, Gaspard Clair François Marie Riche de Prony (1755–1839) embarked on the largest human computation project to that date: to create a 19-volume set of trigonometric and logarithmic tables for the French government. The project took six years and required 96 human computers.</p>
<p class="ref"><b>SEE ALSO</b> <a href="#/Text/9781454926221_epub_c007_r1">First Recorded Use of the Word <i>Computer</i> (1613)</a></p>
<p class="caption"><i>The course of Halley’s Comet across the night sky from April through May of 1910.</i></p>
<div class="fig"><a id="page35"></a><img alt="" src="Images/35-1.jpg"/></div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454926221_epub_c010_r1.vue?aa82585e